export default __webpack_public_path__ + "static/media/ucla.e53328ac.webp";